import { useRouter } from "next/router";
import { useMemo } from "react";
import { PageInfoQueryParams, PageInformation } from "../types";

const usePageInfoFromQuery = (): PageInformation => {
  const router = useRouter();
  const { dealSegment } = router.query as PageInfoQueryParams;

  const sourceInformation: PageInformation = useMemo(
    () => ({
      dealSegment: dealSegment || null,
    }),
    [dealSegment]
  );

  return sourceInformation;
};

export default usePageInfoFromQuery;
